import axios from "axios";

export const api = axios.create({
  baseURL: "/api",
  timeout: 15_000,
});

export type HealthStatus = {
  status: "ok" | "degraded";
  service: string;
  version: string;
  timestamp: string;
  db: "ok" | "error";
};

export async function fetchHealth(): Promise<HealthStatus> {
  const { data } = await api.get<HealthStatus>("/health");
  return data;
}
